import { Flex } from "@chakra-ui/layout";
import { RiFilePaper2Line } from "react-icons/ri";
import { SearchAndFilterTypes } from "src/constants";
import * as Url from "src/services/url";
import * as GQL from "src/types/graphql";
import { useFlags } from "../Providers/FeatureFlagProvider";
import { NavGroup } from "./NavGroup";
import { NavLinkItem } from "./NavLinkItem";
import { SavedViews } from "./SavedViews";

interface NavFormItemProps {
  organization: GQL.Organization;
  formTemplate: GQL.GetFormTemplatesByForLeftNavigation_form_template;
}

export function NavFormItem({ organization, formTemplate }: NavFormItemProps) {
  const flags = useFlags(["saved-views"]);
  const savedViewsEnabled = flags["saved-views"].enabled;

  const newSearchParams = new URLSearchParams();
  newSearchParams.set(
    SearchAndFilterTypes.EnrollmentPeriod,
    formTemplate.enrollment_period_id
  );

  return (
    <NavGroup key={formTemplate.id} label={formTemplate.name} m={0}>
      <Flex direction="column" gap={1} w="100%">
        <NavLinkItem
          label="All"
          tooltip={`${formTemplate.name} - All`}
          url={Url.OrgAdmin.Forms.index({
            organization,
            formTemplateId: formTemplate.id,
            params: newSearchParams.toString(),
          })}
          matchUrlParams={[SearchAndFilterTypes.SavedView]}
          leadIcon={RiFilePaper2Line}
        />

        {savedViewsEnabled && <SavedViews formTemplate={formTemplate} />}
      </Flex>
    </NavGroup>
  );
}
